module.exports = __webpack_public_path__ + "static/media/sc.74bd1af9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sc.svg
// module id = 759
// module chunks = 0